module.exports = __webpack_public_path__ + "static/media/sort-alt.fa549508.svg";